import { ComponentChildren } from "preact";
import { useEffect } from "preact/hooks";
import styles from "./Modal.module.scss";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ComponentChildren;
  align?: "flex-start" | "center" | "flex-end";
  zIndex?: number;
  fullScreen?: boolean;
  className?: string;
}
export interface ModalChildrenProps {
  onClose: () => void;
}
export const Modal = ({
  isOpen,
  onClose,
  children,
  align = "flex-start",
  zIndex,
  fullScreen = false,
  className,
}: ModalProps) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  return (
    <div
      className={`${styles.overlay} ${isOpen ? styles.visible : styles.hidden}`}
      style={{ alignItems: align, zIndex }}
      onClick={onClose}
    >
      <div
        className={`${styles.modal} ${fullScreen ? styles.fullScreen : ""} ${className || ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};
